import React, { useState } from 'react';
import styles from '../productFeatureCarousel.module.css';

export function AccordionContent({ html, maxItems = 5 }) {
  const [expanded, setExpanded] = useState(false);

  if (!html) return null;

  // Extract <li> items safely
  const listItems = html.match(/<li[\s\S]*?<\/li>/g) || [];

  const hasMore = listItems.length > maxItems;

  const visibleItems = expanded ? listItems : listItems.slice(0, maxItems);

  return (
    <>
      <ul className={styles.accordionList}>
        {visibleItems.map((li, i) => (
          <li key={i} dangerouslySetInnerHTML={{ __html: li.replaceAll(/<\/?li>/g, '') }} />
        ))}
      </ul>

      {hasMore && (
        <button className={styles.viewMoreBtn} onClick={() => setExpanded(!expanded)}>
          {expanded ? 'View Less' : 'View More'}
        </button>
      )}
    </>
  );
}
